import { DealRegistryPageListDueDiligenceRecordsQuery, Security_Status } from '@/__generated__/graphql';
import { User } from '@/types/user';
import { ROLE } from '@trace-8/trace8-schema';
import { NavigateOptions } from 'react-router-dom';

export const dealRegistryFilterStatus = (status: string) => {
  switch (status) {
    case 'Lead':
      return [Security_Status.Lead];
    case 'Declined':
      return [Security_Status.Declined];
    case 'Due Diligence':
      return [Security_Status.DueDiligence];
    case 'Approved':
      return [Security_Status.Approved];
    case 'Rejected':
      return [Security_Status.Rejected];
    case 'Open':
      return [Security_Status.Open];
    case 'Active':
      return [Security_Status.Active];
    case 'Realized':
      return [Security_Status.Realized];
    case 'Redeemed':
      return [Security_Status.Redeemed];
    case 'All Statuses':
      return [Security_Status.Lead, Security_Status.Declined, Security_Status.DueDiligence, Security_Status.Approved, Security_Status.Rejected];
    default:
      return [];
  }
};

export const actionDropdownItems = (
  row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number],
  user: User,
  openPage: (path: string, options?: NavigateOptions) => void,
  openModalWindow: (row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number], type: string) => void,
  handleUpdateInvestmentStatus: (
    row: DealRegistryPageListDueDiligenceRecordsQuery['listDueDiligenceRecords']['records'][number],
    status: Security_Status
  ) => void
) => {
  const viewDueDiligencenDropdowAction = {
    name: 'View Due Diligence',
    onClick: () => openPage(`/dueDiligence/${row.id}?backToTitle=Deal Registry`)
  };
  const editInvestmentDetailsDropdowAction = {
    name: 'Edit Investment Details',
    onClick: () =>
      openPage('/allocations/modify/', {
        state: {
          investment: row.investment.id,
          isDealRegistry: true
        }
      })
  };
  const deleteDealDropdownAction =
    user?.roles?.includes(ROLE.ADMIN) || user?.roles?.includes(ROLE.SUPER_ADMIN)
      ? [
          {
            name: 'Delete',
            onClick: () => openModalWindow(row, 'delete-deal')
          }
        ]
      : [];
  const commonDropdownActions = [
    viewDueDiligencenDropdowAction,
    {
      name: 'Edit Deal',
      onClick: () => openPage(`/dueDiligence/modify/?recordId=${row.id}&status=${Security_Status.Lead}&backToTitle=Deal Registry`)
    }
  ];

  switch (row.investment.securityStatus) {
    case 'LEAD':
      return [
        {
          name: 'Start Due Diligence',
          onClick: () => openModalWindow(row, 'start-diligence')
        },
        {
          name: 'Decline',
          onClick: () => handleUpdateInvestmentStatus(row, Security_Status.Declined)
        },
        ...commonDropdownActions,
        ...(row.dealAssistantAIRuns.length === 0
          ? [
              {
                name: 'Generate AI Suggestions',
                onClick: () => openModalWindow(row, 'ai-suggestions')
              }
            ]
          : []),
        ...deleteDealDropdownAction
      ];
    case 'DECLINED':
      return [
        ...commonDropdownActions,
        {
          name: 'Reopen as Lead',
          onClick: () => handleUpdateInvestmentStatus(row, Security_Status.Lead)
        },
        ...deleteDealDropdownAction
      ];
    case 'DUE_DILIGENCE':
      return [
        ...commonDropdownActions,
        ...(row.dealAssistantAIRuns.length === 0
          ? [
              {
                name: 'Generate AI Suggestions',
                onClick: () => openModalWindow(row, 'ai-suggestions')
              }
            ]
          : []),
        ...deleteDealDropdownAction
      ];
    case 'APPROVED':
      return [...commonDropdownActions, ...deleteDealDropdownAction];
    case 'REJECTED':
      return [...commonDropdownActions, ...deleteDealDropdownAction];
    case 'OPEN':
      return [viewDueDiligencenDropdowAction, editInvestmentDetailsDropdowAction, ...deleteDealDropdownAction];
    case 'ACTIVE':
      return [viewDueDiligencenDropdowAction, editInvestmentDetailsDropdowAction, ...deleteDealDropdownAction];
    case 'REALIZED':
      return [...commonDropdownActions, ...deleteDealDropdownAction];
    case 'REDEEMED':
      return [...commonDropdownActions, ...deleteDealDropdownAction];
    default:
      return [];
  }
};
